import { render, staticRenderFns } from "./OrganismCustomerDetail.vue?vue&type=template&id=1a34b1de&scoped=true&"
import script from "./OrganismCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./OrganismCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCustomerDetail.vue?vue&type=style&index=0&id=1a34b1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a34b1de",
  null
  
)

export default component.exports